import React, { Component } from 'react';
import '../../styles/column.scss';
import { Row } from './index';
import { getPercentage, sortPlayersDesc } from '../../index';
import { Player } from 'src/mundial/requests/interfaces';

interface IColumnProps {
    type: string;
    width: string;
    rows: string;
    players: Player[];
    classNameMovePlayer: string;
}

export default class Column extends Component<IColumnProps> {
    type: string;
    width: string;
    rows: number;
    height: number;
    style: {
        width: string;
    };
    state: {
        height: number;
        players?: Player[];
    };
    classNameMovePlayer: string;

    constructor(props: IColumnProps) {
        super(props);
        this.type = this.props.type || '';
        this.width = this.props.width || '';
        this.rows = parseInt(this.props.rows) || 0;
        this.height = getPercentage(this.rows);
        this.style = {
            width: this.width,
        };
        this.state = {
            height: this.height,
        };
        this.classNameMovePlayer = this.props.classNameMovePlayer || '';

        this.isForward = this.isForward.bind(this);
    }

    isForward(index: number) {
        const numberRowsAllowed: number[] = [3, 4, 5];
        const isAllowed = numberRowsAllowed.includes(this.rows);
        const finishElement = this.rows - 1;

        return isAllowed && (index === 0 || index === finishElement) ? true : false;
    }

    render() {
        const { height } = this.state;
        const players = this.props.players || [];
        const sizePlayers = players.length;
        const sortPlayer = players.sort(sortPlayersDesc);
        return (
            <div id="columnFormation" className={`column-${this.type}`} style={this.style}>
                {sortPlayer.map((player, index) => (
                    <Row
                        key={index}
                        type={this.type}
                        height={`${height - 0.5}%`}
                        forward={this.isForward(index)}
                        player={player}
                        classNameMovePlayer={this.classNameMovePlayer}
                        idPlayerPosition={index}
                        sizePlayers={sizePlayers}
                    />
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/GridPositions/Column.tsx